import { ReactElement } from "react";
import useCommonPageView from "src/app/hooks/useCommonPageView";

import type { LandingLang } from "./constants";
import LandingBody from "./LandingBody";
import LandingFooter from "./LandingFooter";
import LandingHeader from "./LandingHeader";
import { LandingLangContext } from "./landingLang";

import styles from "./LandingPage.module.scss";

interface LegacyPageProps {
  lang: LandingLang;
}

// The 1.0 page, kept as the A/B control while the 2.0 layouts are tested.
export default function LegacyPage({ lang }: LegacyPageProps): ReactElement {
  useCommonPageView();

  return (
    <LandingLangContext.Provider value={lang}>
      <div className={styles.landingPage}>
        <LandingHeader />
        <LandingBody lang={lang} />
        <LandingFooter lang={lang} />
      </div>
    </LandingLangContext.Provider>
  );
}
